import { createDynamicSlice } from ".";
import { getDiemListThunk } from "../thunks/diemsThunk";

export const diemsSlice = createDynamicSlice({
  name: "diems",
  thunk: getDiemListThunk,
  listMode: true,
  resetActionName: "resetDiems",
});

export const diemsReducer = diemsSlice.reducer;
export const { resetDiem } = diemsSlice.actions;
